import { Component, ElementRef, OnInit, ViewChild, Renderer2, Inject, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { WebsiteService } from 'src/app/_services/website.service';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import { FeedbackModalComponent } from 'src/app/Components/feedback-modal/feedback-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
//declare function ire(string,{}): any;
function _window() : any {
  // return the global native browser window object
  return window;
}

declare var $: any;
import * as $ from 'jquery';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-parapharsing-tool',
  templateUrl: './parapharsing-tool.component.html',
  styleUrls: ['./parapharsing-tool.component.scss']
})
export class ParapharsingToolComponent implements OnInit {
  creditsDetails: any;
  amplitudeService: any;
  trinkaCloudUrl = environment.trinkaCloudUrl;
  @ViewChild('inputEditor', { static: false }) set inputContent(content: ElementRef) {
    if(content) {
      this._inputEditor = content;
    }
  }

  @ViewChild('outputEditor', { static: false }) set outputContent(content: ElementRef) {
    if(content) {
      this._outputEditor = content;
    }
  }

  @ViewChild('popover', { static: false }) private _popover!: ElementRef;
  @ViewChild('alternativesPopover', { static: false }) private _alternativesPopover!: ElementRef;
  @ViewChild('popoverOverlay', { static: false }) private _popoverOverlay!: ElementRef;

  private _inputEditor!: any;
  private _outputEditor!: any;
  private _snackBarDuration: number = 3000;
  private _delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
  private _paraphraseResponse: any;
  private _wrapper: HTMLElement = document.createElement('div');
  private _paragraphToSentence: Map<string, any> = new Map();
  private _sentenceToAlternatives: Map<string, any> = new Map();
  currentSelectedSentenceState: any = {
    index: -1,
    alternatives: {},
    sentenceTag: null
  };
  wordCounts: any = {
    input: 0,
    output: 0
  };
  paraphraseTemperature: number = 1.5;
  toggleDiffOptionModel: boolean = true;
  isLimitExhausted: boolean = false;
  aboveLimitText: string = '';
  loader: boolean = false;
  paraphraserLimit: number = 500;


  constructor(
    private _appService: WebsiteService,
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    private _dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Free  AI Paraphrasing Tool: Paraphrase Text Instantly (No Sign Up) ');
    this.metaTagService.updateTag({ name: 'description', content: "Trinka’s AI-powered paraphrasing tool helps students and professionals to instantly paraphrase, edit, and rephrase their sentences with ease. Paraphrase Now!" });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Free  AI Paraphrasing Tool: Paraphrase Text Instantly (No Sign Up) ' });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka’s AI-powered paraphrasing tool helps students and professionals to instantly paraphrase, edit, and rephrase their sentences with ease. Paraphrase Now!" });
    this.metaTagService.updateTag({ name: 'keywords', content: 'paraphrasing tool, sentence rephraser, paraphraser, online paraphraser, rephrase online, paraphrasing meaning, rewrite article, rephrase sentence online, online paraphrasing tool, paraphrasing tool free, rewriter tool, rephrase tool, sentence changer, paraphrasing tool online free' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/paraphrasing-tool' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/online_paraphrase_banner.svg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Free  AI Paraphrasing Tool: Paraphrase Text Instantly (No Sign Up) ' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinka’s AI-powered paraphrasing tool helps students and professionals to instantly paraphrase, edit, and rephrase their sentences with ease. Paraphrase Now!" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/online_paraphrase_banner.svg' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/paraphrasing-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/paraphrasing-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/paraphrasing-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/paraphrasing-tool' });
    //this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/paraphrasing-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/paraphrasing-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/paraphrasing-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/paraphrasing-tool' });
    //this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/paraphrasing-tool' });
    this._intialSetup();

    if (isPlatformServer(this.platformId)) {
      const script = this._renderer2.createElement('script');
      script.type = 'application/ld+json';
      script.text = `{"@context":"https://schema.org","@graph":[{"@type":"BreadcrumbList","@id":"https://www.trinka.ai/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://www.trinka.ai/"},{"@type":"ListItem","position":2,"name":"Paraphrasing Tool","item":"https://www.trinka.ai/paraphrasing-tool"}]},{"@type":"ProfessionalService","@id":"https://www.trinka.ai/#service","name":"Paraphrasing Tool","image":"https://www.trinka.ai/assets/images/trinka_logo.svg","url":"https://www.trinka.ai/paraphrasing-tool","logo":"https://www.trinka.ai/assets/images/trinka_logo.svg","description":"Trinka's Paraphrasing Tool rewrites content for clarity, conciseness, and formal tone. Ideal for academic and professional use, it preserves original meaning while enhancing expression.","areaServed":{"@type":"Country","name":"Global"},"priceRange":"$0 - $20/month","contactPoint":{"@type":"ContactPoint","telephone":"+91-22-6193-8200","contactType":"Customer Support","email":"support@trinka.ai","availableLanguage":["English"]},"address":{"@type":"PostalAddress","streetAddress":"801, 8th Floor, Techniplex – II, Off, Swami Vivekananda Rd, Goregaon","addressLocality":"Mumbai","addressRegion":"Maharashtra","postalCode":"400062","addressCountry":"IN"},"sameAs":["https://www.facebook.com/thetrinkaai/","https://www.instagram.com/thetrinkaai/","https://x.com/thetrinkaai","https://www.linkedin.com/company/thetrinkaai/","https://www.youtube.com/channel/UC1PNKZCxdUArpPVr5YFaYcA"]},{"@type":"WebPage","@id":"https://www.trinka.ai/paraphrasing-tool#webpage","url":"https://www.trinka.ai/paraphrasing-tool","name":"Paraphrasing Tool – Trinka AI","description":"Trinka’s Paraphrasing Tool helps rewrite academic and technical content with better clarity and tone, ideal for researchers and professionals.","inLanguage":"en","isPartOf":{"@type":"WebSite","@id":"https://www.trinka.ai/#website"}},{"@type":"FAQPage","@id":"https://www.trinka.ai/paraphrasing-tool#faq","mainEntity":[{"@type":"Question","name":"What is Trinka's Paraphrasing Tool?","acceptedAnswer":{"@type":"Answer","text":"Trinka's Paraphraser is a free online paraphrasing tool that helps generate high-quality paraphrases while preserving the original meaning of the text."}},{"@type":"Question","name":"How to use Trinka's Paraphrasing tool?","acceptedAnswer":{"@type":"Answer","text":"Paste your content, click on the paraphrase button, review the generated suggestions, and use the paraphrased version as needed."}},{"@type":"Question","name":"How does Trinka Paraphrasing tool work?","acceptedAnswer":{"@type":"Answer","text":"Trinka Paraphrasing tool uses advanced AI algorithms to analyze and rephrase text while maintaining clarity, coherence, and readability."}},{"@type":"Question","name":"Is Trinka's Paraphrasing Tool accessible online or requires installation?","acceptedAnswer":{"@type":"Answer","text":"Trinka's Paraphrasing Tool is available online and does not require any installation."}},{"@type":"Question","name":"What makes Trinka's Paraphraser stand out from other paraphrasing tools?","acceptedAnswer":{"@type":"Answer","text":"Trinka offers real-time paraphrasing, customizable rewriting levels, multiple suggestions, and built-in grammar correction."}},{"@type":"Question","name":"Who can use Trinka's Paraphraser?","acceptedAnswer":{"@type":"Answer","text":"Students, researchers, academicians, bloggers, content writers, and professionals can use Trinka's Paraphraser."}},{"@type":"Question","name":"Is there a word limit for paraphrasing with Trinka's Paraphraser?","acceptedAnswer":{"@type":"Answer","text":"Trinka currently allows users to paraphrase up to 500 words at a time with unlimited usage."}},{"@type":"Question","name":"Is Trinka's Rephraser suitable for academic writers?","acceptedAnswer":{"@type":"Answer","text":"Yes, Trinka's Paraphrasing Tool is designed to support academic and research writing while preserving the original meaning."}},{"@type":"Question","name":"Can bloggers use the free AI Paraphrasing tool to improve their content?","acceptedAnswer":{"@type":"Answer","text":"Yes, bloggers can use Trinka's AI Paraphrasing Tool to rewrite articles, improve readability, and enhance content quality."}},{"@type":"Question","name":"How does Trinka's online AI Paraphrasing tool address time-consuming paraphrasing?","acceptedAnswer":{"@type":"Answer","text":"Trinka's real-time paraphrasing feature helps users save time by instantly generating alternative sentence versions."}},{"@type":"Question","name":"How does Trinka's Paraphraser enhance efficiency in writing tasks?","acceptedAnswer":{"@type":"Answer","text":"Trinka helps users overcome writer's block, improve vocabulary usage, and communicate ideas more effectively."}},{"@type":"Question","name":"Can users customize the level of variation in paraphrased text?","acceptedAnswer":{"@type":"Answer","text":"Yes, users can customize the degree of change based on their rewriting requirements."}},{"@type":"Question","name":"How does Trinka's Paraphrasing Tool rectify grammar errors?","acceptedAnswer":{"@type":"Answer","text":"Trinka automatically corrects grammar mistakes using its built-in grammar checking engine."}},{"@type":"Question","name":"How does Trinka's Paraphraser promote originality in academic work?","acceptedAnswer":{"@type":"Answer","text":"Trinka helps create fresh and original content variations while maintaining the intended meaning."}},{"@type":"Question","name":"Can Trinka's Paraphrasing Tool maintain consistency in paraphrased content?","acceptedAnswer":{"@type":"Answer","text":"Yes, Trinka ensures consistency and coherence throughout the paraphrased content."}},{"@type":"Question","name":"How does Trinka's Paraphrasing Tool help avoid unintentional plagiarism?","acceptedAnswer":{"@type":"Answer","text":"Trinka uses advanced paraphrasing algorithms to generate original content and reduce accidental duplication."}},{"@type":"Question","name":"Does Trinka's Paraphrasing Tool offer browser extensions or add-ons?","acceptedAnswer":{"@type":"Answer","text":"Browser extension support for Trinka's Paraphrasing Tool will be available soon."}},{"@type":"Question","name":"Will Trinka's Paraphraser be available as a Word Add-in?","acceptedAnswer":{"@type":"Answer","text":"Yes, Trinka plans to launch its Paraphraser as a Word Add-in for easier accessibility."}},{"@type":"Question","name":"Can Trinka's Paraphrasing Tool integrate with other writing platforms?","acceptedAnswer":{"@type":"Answer","text":"Integration support with popular writing tools and platforms may be introduced in future updates."}},{"@type":"Question","name":"Is customer support available for Trinka Paraphraser users?","acceptedAnswer":{"@type":"Answer","text":"Yes, Trinka offers dedicated customer support to help users with any issues or queries."}},{"@type":"Question","name":"How does Trinka's Paraphrasing Tool handle user data and content?","acceptedAnswer":{"@type":"Answer","text":"Trinka follows strict privacy and security measures and does not store user content."}},{"@type":"Question","name":"Does Trinka's Paraphraser receive regular updates and improvements?","acceptedAnswer":{"@type":"Answer","text":"Yes, Trinka continuously improves its Paraphraser with regular updates and enhancements."}},{"@type":"Question","name":"Are user feedback and suggestions considered for improvements?","acceptedAnswer":{"@type":"Answer","text":"Yes, Trinka values user feedback and uses it to improve features and user experience."}},{"@type":"Question","name":"Does a paraphrasing tool fix grammar mistakes?","acceptedAnswer":{"@type":"Answer","text":"Paraphrasing tools improve sentence structure and clarity, but dedicated grammar checkers are recommended for complete grammatical accuracy."}}]},{"@type":"SoftwareApplication","name":"Paraphrasing Tool","operatingSystem":"All","applicationCategory":"Writing Assistant","applicationSubCategory":"Paraphrasing Tool","description":"Trinka’s AI Paraphrasing Tool rewrites academic and technical text to improve clarity, tone, and flow without changing its meaning.","url":"https://www.trinka.ai/paraphrasing-tool","image":"https://www.trinka.ai/assets/images/tools/paraphrasing-tool/paraphrasing-tool.svg","softwareVersion":"1.0","creator":{"@type":"Organization","name":"Trinka AI","url":"https://www.trinka.ai"},"publisher":{"@type":"Organization","name":"Trinka AI","url":"https://www.trinka.ai"},"offers":{"@type":"Offer","price":"0.00","priceCurrency":"USD","availability":"https://schema.org/InStock","url":"https://www.trinka.ai/paraphrasing-tool"},"aggregateRating":{"@type":"AggregateRating","ratingValue":"4.6","reviewCount":"290"},"featureList":["Rewrite text with formal academic tone","Improve clarity, fluency, and conciseness","Multiple rewriting modes","No content storage – privacy focused","Free and premium access"]}]}`;
      this._renderer2.appendChild(this._document.head, script);
    }

    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });

    if (isPlatformBrowser(this.platformId)) {
      if (window.matchMedia("(max-width: 767px)").matches) {
        // Code for screens below 767px
        $('.left-side .card-footer button').click(function(){
          $('.left-side .editor-wrapper').css({
            'min-height': '120px',
            'max-height': '120px'
          });
          $('.left-side .form-group').css({
            'min-height': '120px'
          });
          $('.left-side').addClass('resultAdjust');
        });
      
        $(".left-side .editor-wrapper").on("click", function() {
          $('.left-side .editor-wrapper').css({
            'min-height': '200px',
            'max-height': '280px'
          });
          $('.left-side.resultAdjust .form-group').css({
            'min-height': '200px'
          });
          $('.left-side').removeClass('resultAdjust');
        });

        $(".right-side .editor-wrapper").on("click", function() {
          $('.left-side .editor-wrapper').css({
            'min-height': '120px',
            'max-height': '120px'
          });
          $('.left-side .form-group').css({
            'min-height': '120px'
          });
        });
      }
    }
  }

  private async _intialSetup() {
    await this._delay(0);
    this._wrapper.classList.add('wrapper');
    this._attachEventListeners();
  }

  private _uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  private _alternativeSelectionCleanup(keepHoverState: boolean = false) {
    if(!keepHoverState) {
      this._clearSelectionState();
    }
    this.currentSelectedSentenceState.alternatives = {};
    this.currentSelectedSentenceState.sentenceTag = null;
    this.currentSelectedSentenceState.index = -1;
    this._popover.nativeElement.style.display = 'none';
    this._alternativesPopover.nativeElement.style.display = 'none';
  }

  private _debounce(callback: Function, interval: number) {
    let debounceTimeoutId: any;

    return (...args: any[]) => {
      clearTimeout(debounceTimeoutId);
      debounceTimeoutId = setTimeout(() => callback.apply(this, args), interval);
    };
  }

  private _throttle(callback: Function, interval: number) {
    let enableCall = true;

    return (...args: any[]) => {
      if (!enableCall) return;

      enableCall = false;
      callback.apply(this, args);
      setTimeout(() => enableCall = true, interval);
    }
  }

  private _attachEventListeners() {
    this._attachPasteEventListener(this._inputEditor.nativeElement);
    this._attachKeydownEventListener(this._inputEditor.nativeElement);
  }

  private _attachKeydownEventListener(element: HTMLElement) {
    element.onkeydown = (e: any) => {
      if(!element.children.length) {
        let newParagraph = document.createElement("p");
        newParagraph.innerHTML = "<br />";
        element.appendChild(newParagraph);
        _window().getSelection().collapse(newParagraph, 0);
        e.preventDefault();
      }
    }

    const observer = new MutationObserver((mutationList, observer) => {
      for(let ilength = mutationList.length, i = 0; i < ilength; ++i) {
        const addedNodes = mutationList[i].addedNodes;
        for(let jlength = addedNodes.length, j = 0; j < jlength; ++j) {
          const node: any = addedNodes[j];
          // console.log(node, node.id);
          // if(!node.id) {
          //   let randomNumber = this._uuidv4();
          //   node.id = `${randomNumber}`;
          // }
        }
      }
    });

    observer.observe(element, { childList: true });
  }

  private _attachPasteEventListener(element: HTMLElement) {
    element.addEventListener('paste', ($event: any) => {
      $event.preventDefault()
      let text = $event.clipboardData.getData('text/plain');
      text = text.replace(/\n{2,}/g, '\n');
      document.execCommand('insertText', false, text);
    });
  }

  private _getMultilineSpanBoundingRect(element: HTMLElement) {
    if(!element.textContent) return;

    // TODO: adjustment is the wrapper padding need re-organize markup structure
    const adjustment = 24;
    const lines = element.textContent.split('\n');
    const lineHeight = parseFloat(getComputedStyle(element).lineHeight);

    let top = Number.MAX_VALUE;
    let bottom = Number.MIN_VALUE;

    for (let i = 0; i < lines.length; i++) {
      const lineTop = element.offsetTop + (i * lineHeight);
      const lineBottom = lineTop + lineHeight;

      if (lineTop < top) {
        top = lineTop;
      }

      if (lineBottom > bottom) {
        bottom = lineBottom;
      }
    }

    let left = element.offsetLeft;
    let right = element.offsetWidth;

    top -= adjustment;
    left -= adjustment;
    right -= adjustment;
    bottom -= adjustment;

    return { top, right, bottom, left };
  }

  private _getRelativePosition(element: HTMLElement) {
    const referenceRect = element.getBoundingClientRect();
    const parentRect = this._popoverOverlay.nativeElement.getBoundingClientRect();
    const popoverRect = this._popover.nativeElement.getBoundingClientRect();

    const relativePos: any = {
      top: (referenceRect.top - parentRect.top) - popoverRect.height,
      right: parentRect.right - referenceRect.right,
      bottom: parentRect.bottom - referenceRect.bottom,
      left: (referenceRect.left - parentRect.left)
    };

    return relativePos;
  }

  private _hoverEventListeners(editor: HTMLElement, eventOriginFromEditor: string) {
    const elements: NodeListOf<HTMLElement> = editor.querySelectorAll('sentence[static="false"]');
    elements.forEach((sentence: HTMLElement) => {
      sentence.addEventListener('mouseover', this._debounce(($event: any) => {
        let target = ($event.target as HTMLElement);

        target.setAttribute('hovered', 'true');

        // find twin node to highlight on selection
        let twin;
        if (eventOriginFromEditor === 'output') {
          twin = this._inputEditor.nativeElement.querySelector(`[id="${target.id}"]`) as HTMLElement;
        } else {
          twin = this._outputEditor.nativeElement.querySelector(`[id="${target.id}"]`) as HTMLElement;
        }

        if (!twin) return;
        twin.setAttribute('hovered', 'true');
      }, 300));

      sentence.addEventListener('mouseout', this._debounce(($event: any) => {
        let target = ($event.target as HTMLElement);

        target.setAttribute('hovered', 'false');

        // find twin node to highlight on selection
        let twin;
        if (eventOriginFromEditor === 'output') {
          twin = this._inputEditor.nativeElement.querySelector(`[id="${target.id}"]`) as HTMLElement;
        } else {
          twin = this._outputEditor.nativeElement.querySelector(`[id="${target.id}"]`) as HTMLElement;
        }

        if (!twin) return;
        twin.setAttribute('hovered', 'false');
      }, 300));
    });
  }

  private _clickEventListeners(editor: HTMLElement, eventOriginFromEditor: string) {
    const elements: NodeListOf<HTMLElement> = editor.querySelectorAll('sentence[static="false"]');
    elements.forEach((sentence: HTMLElement) => {
      sentence.addEventListener('click', this._throttle(($event: any) => {
        let target = ($event.target as HTMLElement);
        this._clearSelectionState();

        target.setAttribute('selected', 'true');
        this.currentSelectedSentenceState.sentenceTag = target;

        // find twin node to highlight on selection
        let twin;
        if(eventOriginFromEditor === 'output') {
          twin = this._inputEditor.nativeElement.querySelector(`[id="${target.id}"]`) as HTMLElement;
        } else {
          twin = this._outputEditor.nativeElement.querySelector(`[id="${target.id}"]`) as HTMLElement;
          this.currentSelectedSentenceState.sentenceTag = twin;
        }

        if(!twin) return;
        twin.setAttribute('selected', 'true');
        // twin.scrollIntoView({behavior: 'smooth'});

        const multiLineRect: any = this._getMultilineSpanBoundingRect(this.currentSelectedSentenceState.sentenceTag);
        const parentRect = this._popoverOverlay.nativeElement.getBoundingClientRect();
        const popoverRect = this._popover.nativeElement.getBoundingClientRect();
        const currentSelectedElement = this.currentSelectedSentenceState.sentenceTag.getBoundingClientRect();
        const top = currentSelectedElement.top - parentRect.top;
        const bottom = parentRect.bottom - currentSelectedElement.bottom;
        const left = currentSelectedElement.left - parentRect.left;
        const right = parentRect.right - currentSelectedElement.right;

        this.currentSelectedSentenceState.alternatives = this._getParaphraserAlternatives(this.currentSelectedSentenceState.sentenceTag.id);
        this.currentSelectedSentenceState.index = Number(this.currentSelectedSentenceState.sentenceTag.getAttribute('paraphrased-index'));
        this._popover.nativeElement.style.display = 'block';
        this._popover.nativeElement.style.top = `${multiLineRect.top - (popoverRect.height + 10)}px`;
        this._popover.nativeElement.style.left = `${multiLineRect.left}px`;

        if(this.currentSelectedSentenceState.alternatives.output_sentence.length && this.currentSelectedSentenceState.alternatives.output_sentence.length > 1) {
          this._alternativesPopover.nativeElement.style.display = 'block';
          this._alternativesPopover.nativeElement.style.top = `${top + currentSelectedElement.height + 25}px`;
          this._alternativesPopover.nativeElement.style.left = `${left}px`;
        }

      }, 300));
    });
  }

  private _getParaphraserAlternatives(id: string) {
    return this._paraphraseResponse.map((paragraph) => paragraph.result)
    .flat()
    .find((sentence) => sentence.file_id === id);
  }

  private _clearSelectionState() {
    let inputEditorAllActiveSentence = this._inputEditor.nativeElement.querySelectorAll('sentence[selected="true"]');
    let outputEditorAllActiveSentence = this._outputEditor.nativeElement.querySelectorAll('sentence[selected="true"]');

    inputEditorAllActiveSentence.forEach((sentence: any) => {
      sentence.setAttribute('selected', 'false');
    });
    outputEditorAllActiveSentence.forEach((sentence: any) => {
      sentence.setAttribute('selected', 'false');
    });
  }

  private _paraphraseFeedback(requestBody: any) {
    this._appService.paraphraseFeedbackRequest(requestBody)
    .subscribe({
      complete: () => { },
      next: (response: any) => {
        this._snackBar.open('Thank you for your feedback!', '', {
          duration: this._snackBarDuration
        });
      },
      error: (error) => {
        this._snackBar.open('Something went wrong, please try again later', '', {
          duration: this._snackBarDuration
        });
      }
    });
  }

  private _makeParaphraseRequest(list: any) {
    this.loader = true;
    this._appService.sendToParaphraseRequest(list)
    .subscribe({
      complete: () => { },
      next: (response: any) => {
        if(!response.length) return;

        this._paraphraseResponse = response;
        this._paragraphToSentence = new Map();
        this._sentenceToAlternatives = new Map();

        response.forEach(paraphrase => {
          this._paragraphToSentence.set(paraphrase.id, paraphrase.result)
          paraphrase.result.forEach(sentence => {
            this._sentenceToAlternatives.set(sentence.file_id, sentence.output_sentence);
          });
        });

        this._updateEditors();
        this.loader = false;
      },
      error: (error) => {
        this.loader = false;
      }
    });
  }

  private _updateEditors() {
    let inputHTML = this._wrapper.cloneNode(true) as HTMLElement;
    let outputHTML = this._wrapper.cloneNode(true) as HTMLElement;

    for (let paragraph of this._paragraphToSentence.keys()) {

      let listOfSentences = this._paragraphToSentence.get(paragraph);
      let inputParagraphNode = inputHTML.querySelector(`[id="${paragraph}"]`);
      let outputParagraphNode = outputHTML.querySelector(`[id="${paragraph}"]`);

      listOfSentences.forEach((sentence: any) => {
        let uniqueId = sentence.file_id;
        let spaceNode = document.createTextNode(" ");
        const newSentence = document.createElement('sentence');
        newSentence.id = uniqueId;
        newSentence.setAttribute('selected', 'false');
        newSentence.innerText = `${sentence.original_sentence}`;
        newSentence.setAttribute('static', 'false');
        inputParagraphNode?.appendChild(newSentence);
        // add space after each sentence
        inputParagraphNode?.appendChild(spaceNode);

        let outputSentence: HTMLElement = newSentence.cloneNode(true) as HTMLElement;
        if(this.toggleDiffOptionModel) {
          outputSentence.innerHTML = `${sentence.output_sentence[0].suggestion_diff}`;
        } else {
          outputSentence.innerText = `${sentence.output_sentence[0].suggestion}`;
        }
        outputSentence.setAttribute('paraphrased-index', '0');
        outputParagraphNode?.appendChild(outputSentence);
        // add space after each sentence
        outputParagraphNode?.appendChild(spaceNode.cloneNode(true));
      });
    }

    this._inputEditor.nativeElement.innerHTML = inputHTML.innerHTML;
    this._outputEditor.nativeElement.innerHTML = outputHTML.innerHTML;

    if(this.aboveLimitText.length) {
      let lastParagraph = this._inputEditor.nativeElement.querySelector('p[class="text-cropped"]');
      let limitExhaustSpan = document.createElement('span');
      limitExhaustSpan.classList.add('limit-exhausted');
      limitExhaustSpan.innerText = this.aboveLimitText;
      lastParagraph.appendChild(limitExhaustSpan);
      this.isLimitExhausted = true;
    }

    this._clickEventListeners(this._inputEditor.nativeElement, 'input');
    this._clickEventListeners(this._outputEditor.nativeElement, 'output');
    this._hoverEventListeners(this._inputEditor.nativeElement, 'input');
    this._hoverEventListeners(this._outputEditor.nativeElement, 'output');
    this._updateCounts();
  }

  private _wordCount(text) {
    return text.split(/(\s+)/).filter((x) => x.trim().length > 0).length;
  }

  private _prepRequestBody() {
    this.aboveLimitText = '';
    this.isLimitExhausted = false;
    let requestBody: any = [];
    let wordCount: number = 0;
    let content = this._inputEditor.nativeElement.innerHTML;
    const domParser = new DOMParser();
    const inputEditorDOM = domParser.parseFromString(content, 'text/html');

    let listOfParagraphs = inputEditorDOM.querySelectorAll('p');

    listOfParagraphs.forEach((paragraph: HTMLElement) => {
      paragraph.classList.remove('text-cropped');
      paragraph.classList.remove('limit-exhausted');
      let id = this._uuidv4();
      let text = paragraph.innerText;
      const newParagraph = document.createElement('p');
      newParagraph.id = id;
      this._wrapper.appendChild(newParagraph);

      if (wordCount < this.paraphraserLimit) {
        let currentText = text.trim().split(/(\s+)/).filter((x) => x.trim().length > 0);
        let currentWordCount = this._wordCount(text.trim());
        if ((wordCount + currentWordCount) > this.paraphraserLimit) {
          let diff = (wordCount + currentWordCount) - (this.paraphraserLimit);
          text = currentText.splice(0, (currentWordCount - diff)).join(' ');
          newParagraph.classList.add('text-cropped');
          this.aboveLimitText = currentText.join(' ');
        }

        // if (wordCount < this.paraphraserLimit) { }
        if(text.trim()) {
          newParagraph.setAttribute('static', 'false');
          let prepParagphForRequest: any = {
            "paragraph": text,
            "id": id,
            "language": "US",
            "temperature": this.paraphraseTemperature
          };
          requestBody.push(prepParagphForRequest);
        } else {
          newParagraph.setAttribute('static', 'true');
        }

        wordCount += currentWordCount;
      } else {
        wordCount += this._wordCount(text.trim());
        this.isLimitExhausted = true;
        newParagraph.setAttribute('static', 'true');
        newParagraph.classList.add('limit-exhausted');
        newParagraph.innerText = text;
      }
    });

    return { requestBody, wordCount };
  }

  private _updateOutputEditorForToggleDiffSuggestions() {
    for (let paragraph of this._paragraphToSentence.keys()) {
      let listOfSentences = this._paragraphToSentence.get(paragraph);
      listOfSentences.forEach((sentence: any) => {
        let uniqueId = sentence.file_id;

        let sentenceTag: HTMLElement = this._outputEditor.nativeElement.querySelector(`[id="${uniqueId}"]`);
        let currentSelectionIndex = sentenceTag.getAttribute('paraphrased-index');

        if(this.toggleDiffOptionModel) {
          sentenceTag.innerHTML = `${sentence.output_sentence[currentSelectionIndex].suggestion_diff}`;
        } else {
          sentenceTag.innerText = `${sentence.output_sentence[currentSelectionIndex].suggestion}`;
        }
      });
    }
  }

  private async _copyTextToClipboard(text: string) {
    if(!text.length) return;
    try {
      await navigator.clipboard.writeText(text);
      this._snackBar.open('Paraphrased text copied', '', {
        duration: this._snackBarDuration
      });
    } catch (e) {
      console.log(e);
      this._snackBar.open('Copy option is not available on Insecure site', '', {
        duration: this._snackBarDuration
      });
    }
  }

  private _pasteHtmlAtCaret(html: any, selectPastedContent: any) {
    var sel, range;
    if (window.getSelection) {
      // IE9 and non-IE
      sel = window.getSelection();
      if (sel.getRangeAt && sel.rangeCount) {
        range = sel.getRangeAt(0);
        range.deleteContents();

        // Range.createContextualFragment() would be useful here but is
        // only relatively recently standardized and is not supported in
        // some browsers (IE9, for one)
        var el = document.createElement("div");
        el.innerHTML = html;
        var frag = document.createDocumentFragment(), node, lastNode;
        while ( (node = el.firstChild) ) {
          lastNode = frag.appendChild(node);
        }
        var firstNode = frag.firstChild;
        range.insertNode(frag);

        // Preserve the selection
        if (lastNode) {
          range = range.cloneRange();
          range.setStartAfter(lastNode);
          if (selectPastedContent) {
            range.setStartBefore(firstNode);
          } else {
            range.collapse(true);
          }
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
    }
  }

  private _checkForLimit() {
    if(this.wordCounts.input <= this.paraphraserLimit) return;
  }

  private _updateCounts() {
    let listOfParagraphs = this._inputEditor.nativeElement.querySelectorAll('p');
    let inputWordCount = 0;
    listOfParagraphs.forEach((paragraph: HTMLElement) => {
      let text = paragraph.innerText;
      inputWordCount += this._wordCount(text.trim());
    });
    this.wordCounts.input = inputWordCount;
    this.wordCounts.output = this._wordCount(this._outputEditor.nativeElement.innerText.trim());

    if(this._inputEditor.nativeElement.innerText === '') this.wordCounts.input = 0;
    if(this._outputEditor.nativeElement.innerText === '') this.wordCounts.output = 0;
  }

  paraphrase() {
    this._alternativeSelectionCleanup(false);
    this._wrapper.innerHTML = '';
    let { requestBody, wordCount } = this._prepRequestBody();
    if(requestBody.length) {
      this._makeParaphraseRequest(requestBody);
    }
  }

  async popoverOptionSelected($event: any, option: string, originalSentence: string = '', paraphrasedSentence: string = '') {
    $event.stopPropagation();

    let requestBody = {};
    switch (option) {
      case 'like':
      case 'dislike':
        requestBody = {
          originalSentence,
          paraphrasedSentence,
          feedback: option
        };
        this._paraphraseFeedback(requestBody);
      break;

      case 'copy':
        this._copyTextToClipboard(paraphrasedSentence);
      break;

      default:
      break;
    }
    // this._alternativeSelectionCleanup(true);
  }

  async copyOutputEditorContent() {
    if(this.toggleDiffOptionModel) return;

    let content = this._outputEditor.nativeElement.innerText;
    this._copyTextToClipboard(content);
  }

  clearEditors() {
    this._inputEditor.nativeElement.innerHTML = '';
    this._outputEditor.nativeElement.innerHTML = '';
    this.paraphraseTemperature = 1.5;
    this.toggleDiffOptionModel = false;

    this._alternativeSelectionCleanup(false);
    this._updateCounts();
  }

  switchToTheAlternative(alternative: any, index: any) {
    if(this.toggleDiffOptionModel) {
      this.currentSelectedSentenceState.sentenceTag.innerHTML = alternative.suggestion_diff;
    } else {
      this.currentSelectedSentenceState.sentenceTag.innerText = alternative.suggestion;
    }
    this.currentSelectedSentenceState.sentenceTag.setAttribute('paraphrased-index', index);
    this._alternativeSelectionCleanup(false);
  }

  onToggleDiffOption() {
    this._alternativeSelectionCleanup(false);
    this._updateOutputEditorForToggleDiffSuggestions();
  }

  closePopover() {
    this._alternativeSelectionCleanup(true);
  }

  onInputEditorChange($event: any) {
    let editor = $event.target;

    this._updateCounts();
    this._checkForLimit();
  }

  setCaret(el: any) {
    let range = document.createRange()
    let sel = window.getSelection()

    range.setStart(el.querySelector('[id="limit-exhausted"]'), 0)
    range.collapse(true)

    sel.removeAllRanges()
    sel.addRange(range)
  }

  placeCaretAfterNode(node) {
    if (typeof window.getSelection != "undefined") {
      var range = document.createRange();
      range.setStartAfter(node);
      range.collapse(true);
      var selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  updateParaphraseTemperature(event) {
    this.paraphrase();
  }

  openFeedbackModal(): void {
    const dialogRef = this._dialog.open(FeedbackModalComponent, {
      width: '464px',
      height: 'auto',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed', result);
    });
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  
}
